import { useEffect, useMemo, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, CircularProgress, Button, Alert } from '@mui/material';
import { useFeaturedRestaurantApi } from '../../Hooks/useFeaturedRestaurantApi';

const PaymentFeaturedStripeSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { verifyFeaturedPayment, loading, error } = useFeaturedRestaurantApi();
  const [resultMessage, setResultMessage] = useState<string>('');
  const [success, setSuccess] = useState<boolean | null>(null);

  const subscriptionId = useMemo(() => searchParams.get('subscriptionId') || '', [searchParams]);
  const sessionId = useMemo(() => searchParams.get('session_id') || searchParams.get('sessionId') || '', [searchParams]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const merchantId: string | undefined = userData?.userId;
    if (!merchantId || !sessionId) return;
    verifyFeaturedPayment({ checkoutId: String(sessionId), merchantId: String(merchantId) })
      .then((resp) => {
        setSuccess(Boolean(resp.success));
        setResultMessage(resp.message || 'Payment verified');
      })
      .catch(() => {
        setSuccess(false);
        setResultMessage('Payment verification failed');
      });
  }, [sessionId, verifyFeaturedPayment]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eaed 100%)' }}>
      <Paper sx={{ p: 4, maxWidth: 560, width: '100%', border: '1px solid #e8eaed', borderRadius: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Featured Listing Payment</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>Subscription: {subscriptionId || 'N/A'}</Typography>

        {loading && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <CircularProgress size={22} />
            <Typography variant="body2">Verifying your payment...</Typography>
          </Box>
        )}

        {!loading && success === true && (
          <Alert severity="success" sx={{ mb: 2 }}>{resultMessage}</Alert>
        )}
        {!loading && success === false && (
          <Alert severity="error" sx={{ mb: 2 }}>{resultMessage || error}</Alert>
        )}

        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button variant="contained" onClick={() => navigate('/layout/makeyourRestaurant')}>Back to Featured</Button>
          <Button variant="outlined" onClick={() => navigate('/layout/dashboard')}>Go to Dashboard</Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default PaymentFeaturedStripeSuccess;


